const doubleListStyles = () => ({
  paper: {
    backgroundColor: '#FFFFFF',
    overflow: 'auto',
    height: 'calc(100vh - 100px)',
    '&::WebkitScrollbar': {
      width: '8px',
      height: '8px'
    },
    /* Track */
    '&::WebkitScrollbarTrack': {
      background: '#ebebeb',
      borderRadius: '10px',
      margin: '2px'
    },
    /* Handle */
    '&::WebkitScrollbarThumb': {
      background: '#9E9E9E',
      borderRadius: '10px'
    },
    /* Handle on hover */
    '&::WebkitScrollbarThumb:hover': {
      background: '#7b7a7a'
    }
  },
  itemId: {
    fontSize: '12px',
    color: '#9E9E9E',
    lineHeight: '16px'
  },
  item: {
    paddingTop: '1px',
    paddingBottom: '1px',
    paddingLeft: '9px'
  },
  itemLabel: {
    marginTop: '0',
    marginBottom: '0'
  },
  itemLabelText: {
    fontSize: '14px',
    lineHeight: '20px'
  },
  tag: {
    color: '#212121',
    'font-size': '12px',
    'line-height': '12px',
    textDecoration: 'none',
    'box-sizing': 'border-box',
    background: '#F5F5F5',
    border: '1px solid #E0E0E0',
    'border-radius': '2px',
    padding: '0 5px',
    marginLeft: '10px'
  },
  selected: {
    paddingTop: '1px',
    paddingBottom: '1px',
    paddingLeft: '9px',
    backgroundColor: '#E3F2FD'
  },
  button: {
    margin: '3px 0',
    borderColor: '#E0E0E0',
    borderRadius: '2px',
    backgroundColor: '#ffffff',
    width: '26px',
    height: '26px',
    minWidth: '26px',
    minHeight: '26px',
    padding: '0 2px',
    '& span': {
      fontSize: '10px',
      padding: 0
    }
  },
  separateButton: {
    margin: '3px 0',
    borderColor: '#E0E0E0',
    borderRadius: '2px',
    backgroundColor: '#ffffff',
    width: '26px',
    height: '26px',
    minWidth: '26px',
    minHeight: '26px',
    padding: '0 2px',
    '& span': {
      fontSize: '10px',
      padding: 0
    },
    marginBottom: '20px'
  },
  groupChevron: {
    fontWeight: '900',
    fontSize: '10px',
    paddingRight: '8px',
    paddingTop: '6px',
    cursor: 'pointer',
    color: '#757575'
  },
  itemsNumberGrid: {
    fontSize: '14px',
    textAlign: 'right',
    color: '#333333'
  },
  gridLarge: {
    maxWidth: '47.83333%',
    flexBasis: '47.83333%',
    height: '100%',
    display: 'flex',
    flexDirection: 'column'
  },
  gridSmall: {
    maxWidth: '4.33333%',
    flexBasis: '4.33333%',
    height: '100%'
  },
  list: {
    paddingTop: 0,
    paddingBottom: 0,
    borderWidth: 0,
    height: 'calc(100% - 16px)'
  },
  fullHeight: {
    height: '100%'
  },
  searchLabel: {
    fontWeight: '600',
    color: '#424242'
  },
  searchBox: {
    marginTop: '3px'
  },
  containerClass: {
    height: 'inherit'
  },
  itemGrid: {
    flex: '1'
  },
  autocompleteSuggestions: {
    zIndex: 3010,
    backgroundColor: '#ffffff'
  },
  pendingResourceWrapper: {
    display: 'flex'
  }
});

export default doubleListStyles;
